import http from 'axios'

export default {
  // Récupère la liste complète des synthèses d'analyses pour un adhérent et une campagne donnés.
  getSyntheseAnalyse: (numtiers, anneeRecolte) => {
    return http.get(`/web/v1/${numtiers}/cloture/${anneeRecolte}/synthese-analyse`)
  },

  // Crée une nouvelle synthèse d'analyse (message initial).
  createSyntheseAnalyse: (numtiers, anneeRecolte, syntheseAnalyse) => {
    return http.post(`/web/v1/${numtiers}/cloture/${anneeRecolte}/synthese-analyse`, syntheseAnalyse)
  },

  // Enregistre le nouvel ordonnancement complet de toutes les synthèses d'analyses.
  saveOrdreSyntheseAnalyse: (numtiers, anneeRecolte, syntheseAnalyse) => {
    return http.post(`/web/v1/${numtiers}/cloture/${anneeRecolte}/synthese-analyse/all`, syntheseAnalyse)
  },

  // Met à jour une synthèse d'analyse existante (principalement son message).
  updateSyntheseAnalyse: (numtiers, anneeRecolte, syntheseAnalyse) => {
    return http.put(`/web/v1/${numtiers}/cloture/${anneeRecolte}/synthese-analyse/${syntheseAnalyse.id}`, syntheseAnalyse)
  },

  // Supprime définitivement une synthèse d'analyse par son identifiant unique.
  deleteSyntheseAnalyse: (numtiers, anneeRecolte, id) => {
    return http.delete(`/web/v1/${numtiers}/cloture/${anneeRecolte}/synthese-analyse/${id}`,)
  }
}
